// Import custom transition functions from the Timedoor module.
import { slideUp, slideDown, slideToggle, fadeOut, fadeIn, fadeToggle } from './modules/transitions';
import './modules/particles';

// Import specific Bootstrap components for modular use in the project.
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Modal from 'bootstrap/js/dist/modal';
import Tabs from 'bootstrap/js/dist/tab';

/**
 * Coding Standards
 * ===========================
 * 1. Functionality Splitting:
 *    - Create distinct, single-purpose functions to improve readability and reusability.
 * 2. Modular Imports:
 *    - Import only the required modules to reduce bundle size and enhance maintainability.
 * 3. Event Listeners:
 *    - Always wrap initialization code inside `DOMContentLoaded` to ensure the DOM is fully loaded.
 */

function hello() {
    const d = new Date()
    let year = d.getFullYear()
    console.log("%c ", "color: #FFFFFF; font-size: 20px"), 
    console.log("%c©" + year + " Timedoor Indonesia.", "color: #FFFFFF; font-size: 25px"), 
    console.log("%cAll rights reserved.", "color: #FFFFFF; font-size: 16px"), 
    console.log("%c ", "color: #FFFFFF; font-size: 20px") 
}

function checkNavbarScrolled() {
    const navbarPrimaryEl = document.querySelector('.custom-navbar');
    const mainEl = document.querySelector('main');

    if (navbarPrimaryEl && mainEl) {
        let lastIsFixed = false;

        function updateNavbar() {
            if (window.scrollY > 200) {
                if (!lastIsFixed) {
                    navbarPrimaryEl.classList.add('scrolled');
                    navbarPrimaryEl.classList.add('fixed');
                    mainEl.style.paddingTop = `${navbarPrimaryEl.offsetHeight}px`;
                    lastIsFixed = true;
                }
                if (window.scrollY > 250) {
                    navbarPrimaryEl.classList.add('in');
                }
            } else if (window.scrollY == 0) {
                if (lastIsFixed) {
                    navbarPrimaryEl.classList.remove('scrolled');
                    navbarPrimaryEl.classList.remove('fixed');
                    navbarPrimaryEl.classList.remove('in');
                    mainEl.style.paddingTop = '';
                    lastIsFixed = false;
                }
            }
        }

        window.addEventListener('scroll', updateNavbar);
        window.addEventListener('resize', () => {
            if (lastIsFixed) {
                mainEl.style.paddingTop = `${navbarPrimaryEl.offsetHeight}px`;
            }
        });
        updateNavbar();
    }
}

function navbarMegaMenu() {
    const childMenus = document.querySelectorAll('.menu-item-has-children');
    const megaMenus = document.querySelectorAll('.menu-item-mega-menu');

    if (!childMenus.length && !megaMenus.length) return;

    // Combine both childMenus and megaMenus into one array
    const menus = [...childMenus, ...megaMenus];

    menus.forEach(menu => {
        menu.addEventListener('click', (e) => {
            e.preventDefault();

            // Close other menus first
            menus.forEach(menuIn => {
                if (menu !== menuIn) {
                    const subMenu = menuIn.querySelector('.sub-menu');
                    const megaMenu = menuIn.querySelector('.mega-menu');
                    if (subMenu) fadeOut(subMenu, 200);
                    if (megaMenu) slideUp(megaMenu);
                }
            });

            // Toggle the visibility of the clicked menu's sub-menu or mega-menu
            const subMenu = menu.querySelector('.sub-menu');
            const megaMenu = menu.querySelector('.mega-menu');
            if (subMenu) fadeToggle(subMenu, 200, () => {
                menu.classList.toggle('is-open');
            });
            if (megaMenu) slideToggle(megaMenu, 400, () => {
                menu.classList.toggle('is-open');
            });
        });

        // Add event listener for sub-menus and mega-menus to stop propagation
        const subMenu = menu.querySelector('.sub-menu');
        const megaMenu = menu.querySelector('.mega-menu');
        if (subMenu) {
            subMenu.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }
        if (megaMenu) {
            megaMenu.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    hello()
    checkNavbarScrolled()
    navbarMegaMenu()
});

// close navbar on click menu in mobile
document.querySelectorAll('.custom-navbar .menu-item').forEach(item => {
    item.addEventListener('click', () => {
        if (window.innerWidth < 768) {
            const offcanvasEl = document.querySelector('.offcanvas.show');
            if (offcanvasEl) {
                const bsOffcanvas = Offcanvas.getInstance(offcanvasEl);
                if (bsOffcanvas) bsOffcanvas.hide();
            }
        }
    });
});
